/**
 * Based off of ant.design colors
 */
export const gray2 = '#fafafa';
export const gray3 = '#f5f5f5';
export const gray4 = '#f0f0f0';
export const gray5 = '#d9d9d9';
export const gray6 = '#bfbfbf';
export const gray7 = '#8c8c8c';
export const gray8 = '#595959';
export const gray10 = '#262626';

export const red6 = '#f5222d';

/**
 * Field Settings Colors:
 * - Field Titles: gray8;
 * - Field Descriptions: gray5;
 * - Field Borders: gray5;
 */
export const BorderGrey = gray5;
export const InputPlaceholderGrey = '#c5c5cc';
export const LightGrey = '#F1F1F1';
export const MediumGrey = '#BAC4CF';
export const DarkGrey = '#535353';
export const BrandBlue = '#266FFA';
export const Black = '#262626';
export const Green = '#4EEB77';
export const Red = red6;
export const Yellow = '#FFC107';
export const White = '#FFFFFF';

export const DarkGreen = '#00DC4E';

export const LightBlueBackground = 'rgba(0,208,255,0.1)';
export const LightBlueBorder = 'rgba(1,196,241,0.4)';

export default {
  gray2,
  gray3,
  gray4,
  gray5,
  gray6,
  gray7,
  gray8,
  red6,

  White,
  Black,
  DarkGrey,
  BorderGrey,
  LightGrey,
  BrandBlue,
  InputPlaceholderGrey,
  Green,
  Red,
  Yellow,

  LightBlueBorder,
  LightBlueBackground
};
